<template>
	<div>
		<div class="row">
			<div class="col-12">
				<InputText id="name" name="name" :form="values" :errors="errors" maxLength="50"/>
			</div>
			<div class="col-12">
				<InputSelect id="job_id" name="job" :options="jobs" label="value" :form="values" :errors="errors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<button class="button-action" @click="save">{{ newPerson ? 'Add Person' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText,
		InputSelect
	},
	props: [
		'person',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['name', 'job_id'],
			newPerson: true
		}
	},
	computed: {
		jobs() {
			return this.$store.getters['jobs/list'].map(job => {
				return {
					key: job.id,
					value: job.name
				}
			})
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					if(field === 'job_id') {
						this.errors[field] = 'This field is required. Add jobs in ‘Options, Jobs’'
					} else {
						this.errors[field] = 'This field is required.'
					}
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			const action = this.newPerson ? 'create' : 'update'
			const postActionDescription = this.newPerson ? 'Added' : 'Updated'
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`people/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `People ${this.values.name} ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.person) {
			this.values = JSON.parse(JSON.stringify(this.person))
			this.newPerson = false
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/People/Form.vue